package com.xtream.data_kmp.dto


import androidx.room3.Entity
import androidx.room3.Ignore
import androidx.room3.Index
import androidx.room3.PrimaryKey

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/*
    val tv_archive: Int,
    val tv_archive_duration: Int,
    val epg_channel_id: String?,
 */
const val liveStreamsTable="liveStreamsTable"

@Serializable
@Entity(liveStreamsTable,
        indices = [Index(value = ["categoryId","name","num"])]
)

data class LiveStream(

    @SerialName("stream_id")
    @PrimaryKey
    override val streamId: Int,

    override val added: String="",

    @SerialName("category_id")
   override val categoryId: Int=-1,

    @SerialName("custom_sid")
   override val customSid: String?=null,

    @SerialName("direct_source")
   override val directSource: String?=null,

    @SerialName("is_adult")
   override val isAdult: Int=0,
    override var name: String="",
    override val num: Int?=null,
    @SerialName("stream_icon")
   override val streamIcon: String?=null,

    @Deprecated("streamType is deprecated", replaceWith = ReplaceWith("type"))
    @SerialName("stream_type")
   override val streamType: String="",


    @SerialName("epg_channel_id")
    val epgChannelId: String?=null,
    @SerialName("tv_archive")
    val tvArchive: Int?=null,
    @SerialName("tv_archive_duration")
    val tvArchiveDuration: Int?=null
): BaseStream {
    @kotlinx.serialization.Transient
    @Ignore
    override val type: StreamType = StreamType.ICON
}